<sh-modal class="bp-manager-modal" [visible]="true" [sticky]="true" id="business-partner-management-modal"
  [attr.label]="viewMode === 'overview' ? ('businessPartner.modal.titleOverview' | transloco) : (isCreating ? ('businessPartner.modal.titleNew' | transloco) : ('businessPartner.modal.titleEdit' | transloco))"
  modal-height="86vh" [attr.modal-width]="'min(94vw, 1580px)'"
  [attr.accessible-close-label]="'businessPartner.modal.closeAriaLabel' | transloco" (modal-closed)="closeDialog()">

  <sh-icon id="business-partner-management-icon-close-business-partner-ma" slot="functions" icon="cancel" size="s" button
  [attr.accessible-label]="'businessPartner.modal.closeAriaLabel' | transloco" (click)="closeDialog()"></sh-icon>

  <div class="bp-manager__modal-body">
    @if (viewMode === 'overview') {
      <div class="bp-manager__surface bp-manager__surface--overview">
        <div class="bp-manager__overview-toolbar">
          <div>
            <div class="bp-manager__metric-label">{{ 'businessPartner.overview.configuredDomains' | transloco }}</div>
            <div class="bp-manager__metric-value">{{ overviewRows.length }}</div>
          </div>
          <sh-button id="business-partner-management-button-new-business-partner" [attr.label]="'businessPartner.overview.newPartner' | transloco" size="max-content" icon="plus" icon-position="left" (click)="startCreate()"></sh-button>
        </div>
        @if (loading) {
          <div class="bp-manager__state">
            <sh-spinner id="business-partner-management-spinner-3"></sh-spinner>
          </div>
        }
        @if (!loading && overviewError) {
          <div class="bp-manager__state bp-manager__state--error">
            <sh-icon id="business-partner-management-icon-error" icon="error" size="m"></sh-icon>
            <div>{{ 'businessPartner.overview.loadingError' | transloco }}</div>
          </div>
        }
        @if (!loading && !overviewError) {
          <p-table [value]="overviewRows" [scrollable]="true" scrollHeight="flex"
            [sortField]="'domainName'" [sortOrder]="1" class="bp-overview-table">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="companyName">{{ 'businessPartner.overview.table.companyName' | transloco }} <p-sortIcon field="companyName"></p-sortIcon></th>
                <th pSortableColumn="domainName">{{ 'businessPartner.overview.table.domainName' | transloco }} <p-sortIcon field="domainName"></p-sortIcon></th>
                <th pSortableColumn="manualUserCount">{{ 'businessPartner.overview.table.manualUsers' | transloco }} <p-sortIcon field="manualUserCount"></p-sortIcon></th>
                <th pSortableColumn="countryCount">{{ 'businessPartner.overview.table.countries' | transloco }} <p-sortIcon field="countryCount"></p-sortIcon></th>
                <th pSortableColumn="siteCount">{{ 'businessPartner.overview.table.sites' | transloco }} <p-sortIcon field="siteCount"></p-sortIcon></th>
                <th pSortableColumn="access.chatbot">{{ 'businessPartner.overview.table.chatbot' | transloco }} <p-sortIcon field="access.chatbot"></p-sortIcon></th>
                <th pSortableColumn="access.machineData">{{ 'businessPartner.overview.table.machineData' | transloco }} <p-sortIcon field="access.machineData"></p-sortIcon></th>
                <th pSortableColumn="access.serviceData">{{ 'businessPartner.overview.table.serviceData' | transloco }} <p-sortIcon field="access.serviceData"></p-sortIcon></th>
                <th pSortableColumn="lastUpdatedDate">{{ 'businessPartner.overview.table.lastUpdated' | transloco }} <p-sortIcon field="lastUpdatedDate"></p-sortIcon></th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
              <tr>
                <td>
                  <div class="bp-company-cell__name">{{ row.companyName }}</div>
                </td>
                <td>
                  {{ row.domainName }}
                </td>
                <td>
                  <button type="button" class="bp-link-button bp-link-button--neutral" (click)="openManualUsersDialog(row)">{{ row.manualUserCount }}</button>
                </td>
                <td>
                  <button type="button" class="bp-link-button bp-link-button--neutral" (click)="openCountriesDialog(row)">{{ row.countryCount }}</button>
                </td>
                <td>
                  <div class="bp-overview-count-cell">
                    <button type="button" class="bp-link-button bp-link-button--neutral" (click)="openSitesDialog(row)">{{ row.siteCount }}</button>
                    @if (row.siteCount === 0) {
                      <sh-icon [attr.id]="'bp-sites-warning-' + rowIndex" icon="warning" size="xs"
                      class="bp-overview-warning" [attr.aria-label]="'businessPartner.overview.noSitesAriaLabel' | transloco"></sh-icon>
                      <sh-popover id="business-partner-management-popover-5" [target]="'bp-sites-warning-' + rowIndex" type="warning" position="right-up" passive>
                        {{ 'businessPartner.overview.sitesWarning' | transloco }}
                      </sh-popover>
                    }
                  </div>
                </td>
                <td>
                  <span class="bp-flag" [class.bp-flag--active]="row.access.chatbot">{{ row.access.chatbot ? ('businessPartner.overview.enabled' | transloco) : ('businessPartner.overview.disabled' | transloco) }}</span>
                </td>
                <td>
                  <span class="bp-flag" [class.bp-flag--active]="row.access.machineData">{{ row.access.machineData ? ('businessPartner.overview.enabled' | transloco) : ('businessPartner.overview.disabled' | transloco) }}</span>
                </td>
                <td>
                  <span class="bp-flag" [class.bp-flag--active]="row.access.serviceData">{{ row.access.serviceData ? ('businessPartner.overview.enabled' | transloco) : ('businessPartner.overview.disabled' | transloco) }}</span>
                </td>
                <td>{{ formatDate(row.lastUpdatedDate) }}</td>
                <td>
                  <div class="bp-actions">
                    <sh-button id="business-partner-management-button-edit" [attr.label]="'businessPartner.overview.button.edit' | transloco" icon="edit" icon-position="left" size="max-content" color="secondary" (click)="editPartner(row)"></sh-button>
                    <sh-button id="business-partner-management-button-delete" [attr.label]="'businessPartner.overview.button.delete' | transloco" icon="delete" icon-position="left" size="max-content" color="secondary" (click)="deletePartner(row)"></sh-button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="10">
                  <div class="bp-manager__state">{{ 'businessPartner.overview.empty' | transloco }}</div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        }
        <sh-modal class="bp-delete-modal" sticky id="bp-delete-partner-modal" [attr.label]="'businessPartner.delete.title' | transloco" modal-height="auto" modal-width="320px"
          [visible]="deleteModalOpen" (modal-closed)="closeDeleteModal()">
          <div class="bp-delete-modal__body">
            <span>{{ 'businessPartner.delete.message' | transloco }}</span>
            @if (pendingDeletePartner) {
              <strong>{{ pendingDeletePartner.domainName }}</strong>
            }
          </div>
          @if (deletingPartner) {
            <sh-spinner id="business-partner-management-spinner-8" size="s"></sh-spinner>
          }
          <sh-button id="business-partner-management-button-cancel" [disabled]="deletingPartner" color="secondary" slot="footer" [attr.label]="'businessPartner.delete.cancel' | transloco"
          (click)="closeDeleteModal()"></sh-button>
          <sh-button id="business-partner-management-button-delete" [disabled]="deletingPartner" size="max-content" icon="delete" icon-position="left" slot="footer" [attr.label]="'businessPartner.delete.confirm' | transloco"
          (click)="confirmDeletePartner()"></sh-button>
        </sh-modal>
      </div>
    }

    @if (viewMode === 'edit') {
      <div class="bp-manager__surface bp-manager__surface--edit">
        <div class="bp-editor__stepper bp-editor__stepper--setup">
          <sh-stepper id="business-partner-management-stepper-11" [value]="editorStep" color="primary">
            <sh-stepper-item id="business-partner-management-stepper-item-base-information" [attr.label]="'businessPartner.stepper.baseInfo' | transloco"
              (click)="navigateToEditorStep(1)"
            [active]="editorStep === 1" [type]="getBaseInfoStepState()"></sh-stepper-item>
            <sh-stepper-item id="business-partner-management-stepper-item-adding-users" [attr.label]="'businessPartner.stepper.addingUsers' | transloco"
              (click)="navigateToEditorStep(2)"
              [disabled]="!canNavigateToUsersStep()"
            [active]="editorStep === 2" [type]="getManualUsersStepState()"></sh-stepper-item>
            <sh-stepper-item id="business-partner-management-stepper-item-customer-sites" [attr.label]="'businessPartner.stepper.customerSites' | transloco"
              (click)="navigateToEditorStep(3)"
              [disabled]="!canNavigateToSiteStep()"
            [active]="editorStep === 3"></sh-stepper-item>
          </sh-stepper>
        </div>
        <div class="bp-editor__stage">
          @if (editorStep === 1) {
            <div class="bp-editor__flow-section bp-editor__flow-section--setup">
              <div class="bp-editor__intro">
                <div class="bp-editor__intro-title">
                  {{ isCreating ? ('businessPartner.editor.setupTitle' | transloco) : ('businessPartner.editor.reviewTitle' | transloco) }}
                </div>
                <div class="bp-editor__intro-copy">
                  {{ isCreating
                  ? ('businessPartner.editor.setupIntro' | transloco)
                  : ('businessPartner.editor.reviewIntro' | transloco) }}
                </div>
              </div>
              <div class="bp-editor__meta-grid bp-editor__meta-grid--setup">
                <div class="bp-editor__section-copy bp-editor__section-copy--full">
                  {{ 'businessPartner.editor.step1Copy' | transloco }}
                </div>
                <sh-input-text id="business-partner-management-input-text-company-name" [attr.label]="'businessPartner.editor.companyNameLabel' | transloco" autocomplete="organization" [(ngModel)]="draft.companyName"
                  [mandatory]="true" [error]="showCompanyNameError()"
                  [errorMessage]="getCompanyNameValidationError()"
                  [success]="showCompanyNameSuccess()"
                  (ngModelChange)="onBaseInfoChanged()"
                  (focusin)="onBaseInfoFocus('companyName')"
                (focusout)="onCompanyNameBlur()"></sh-input-text>
                <sh-input-text id="business-partner-management-input-text-domain-name" [attr.label]="'businessPartner.editor.domainNameLabel' | transloco" [attr.hint]="'businessPartner.editor.domainNameHint' | transloco"
                  [(ngModel)]="draft.domainName" [mandatory]="true" [error]="showDomainNameError()"
                  [errorMessage]="getDomainValidationError()"
                  [success]="showDomainNameSuccess()"
                  (ngModelChange)="onDomainNameChanged($event)"
                  (focusin)="onBaseInfoFocus('domainName')"
                (focusout)="onDomainNameBlur()"></sh-input-text>
              </div>
              <div class="bp-editor__access bp-editor__access-panel">
                <p class="bp-editor__section-copy">
                  {{ 'businessPartner.editor.capabilitiesStep' | transloco }}
                </p>
                <div class="bp-editor__access-grid">
                  <div class="bp-editor__capability-item">
                    <div class="bp-editor__capability-toggle">
                      <sh-checkbox id="business-partner-management-checkbox-chatbot-access" [active]="draft.access.chatbot" disabled [attr.label]="'businessPartner.editor.chatbotAccess' | transloco"></sh-checkbox>
                      <sh-icon id="bp-capability-chatbot" class="bp-editor__capability-help" icon="confirmation" button size="xs"
                      [attr.aria-label]="'businessPartner.editor.explainChatbot' | transloco"></sh-icon>
                    </div>
                    <sh-popover id="business-partner-management-popover-18" target="bp-capability-chatbot" type="info" position="top-start" [passive]="true">
                      {{ 'businessPartner.editor.chatbotPopover' | transloco }}
                    </sh-popover>
                  </div>
                  <div class="bp-editor__capability-item">
                    <div class="bp-editor__capability-toggle">
                      <sh-checkbox id="business-partner-management-checkbox-machine-data-access" [active]="draft.access.machineData" [attr.label]="'businessPartner.editor.machineDataAccess' | transloco" (checked)="toggleAccess('machineData')"></sh-checkbox>
                      <sh-icon id="bp-capability-machine" class="bp-editor__capability-help" icon="confirmation" button size="xs"
                      [attr.aria-label]="'businessPartner.editor.explainMachineData' | transloco"></sh-icon>
                    </div>
                    <sh-popover id="business-partner-management-popover-20" target="bp-capability-machine" type="info" position="top-start" [passive]="true">
                      {{ 'businessPartner.editor.machineDataPopover' | transloco }}
                    </sh-popover>
                  </div>
                  <div class="bp-editor__capability-item">
                    <div class="bp-editor__capability-toggle">
                      <sh-checkbox id="business-partner-management-checkbox-service-data-access" [active]="draft.access.serviceData" [attr.label]="'businessPartner.editor.serviceDataAccess' | transloco" (checked)="toggleAccess('serviceData')"></sh-checkbox>
                      <sh-icon id="bp-capability-service" class="bp-editor__capability-help" icon="confirmation" button size="xs"
                      [attr.aria-label]="'businessPartner.editor.explainServiceData' | transloco"></sh-icon>
                    </div>
                    <sh-popover id="business-partner-management-popover-22" target="bp-capability-service" type="info" position="top-start" [passive]="true">
                      {{ 'businessPartner.editor.serviceDataPopover' | transloco }}
                    </sh-popover>
                  </div>
                </div>
                @if (showCapabilitiesError()) {
                  <div class="bp-editor__validation">{{ getCapabilitiesValidationError() }}</div>
                }
              </div>
              <div class="bp-editor__footer">
                <div class="bp-editor__status">
                  @if (formError) {
                    <span class="bp-editor__error">{{ formError }}</span>
                  }
                </div>
                <div class="bp-editor__actions">
                  <sh-button id="business-partner-management-button-cancel" [attr.label]="'businessPartner.editor.cancel' | transloco" size="max-content" icon-position="left" icon="cancel" color="secondary" (click)="returnToOverview()"></sh-button>
                  <sh-button id="business-partner-management-button-arrow-right" [attr.label]="isCreating ? ('businessPartner.editor.continue' | transloco) : ('businessPartner.editor.review' | transloco)" size="max-content" icon="arrow-right" icon-position="left" class="bp-button--icon-right"
                    [disabled]="validatingOnboarding || !hasSelectedCapability()"
                  (click)="continueToManualUsersStep()"></sh-button>
                </div>
              </div>
            </div>
          } @else {
            @if (editorStep === 2) {
              <div class="bp-editor__flow-section bp-editor__flow-section--setup">
                <div class="bp-editor__intro bp-editor__intro--users">
                  <div>
                    <div class="bp-manager__metric-label">{{ 'businessPartner.users.metricLabel' | transloco }}</div>
                    <div class="bp-manager__metric-value">{{ getConfiguredManualUserCount() }}</div>
                  </div>
                  <div class="bp-editor__intro-copy bp-editor__intro-copy--wide">
                    <div class="bp-editor__intro-title">{{ 'businessPartner.users.title' | transloco }}</div>
                    <p class="bp-editor__section-copy bp-editor__section-copy--users">
                      {{ 'businessPartner.users.description' | transloco }} <strong>{{ draft.domainName || 'current' }}</strong> {{ 'businessPartner.users.descriptionSuffix' | transloco }} <strong>{{ draft.domainName || 'current' }}</strong> {{ 'businessPartner.users.descriptionEnd' | transloco }}
                    </p>
                  </div>
                </div>
                <div class="bp-editor__manual-users-panel">
                  <div class="bp-editor__section-copy">
                    {{ 'businessPartner.users.step2Copy' | transloco }}
                  </div>
                  <div class="bp-editor__manual-users-list">
                    @for (email of manualUserInputs; track trackManualUserInput(index); let index = $index) {
                      <div class="bp-editor__manual-user-row">
                        <sh-input-text id="business-partner-management-input-text-user-email-address" [attr.label]="'businessPartner.users.emailLabel' | transloco" autocomplete="email"
                          [ngModel]="email"
                          [error]="showManualUserError(index)"
                          [errorMessage]="getManualUserValidationError(index)"
                          [success]="showManualUserSuccess(index)"
                          (ngModelChange)="onManualUserInputChange(index, $event)"
                          (focusin)="onManualUserInputFocus(index)"
                        (focusout)="onManualUserInputBlur(index)"></sh-input-text>
                        @if (isAddManualUserButtonVisible(index)) {
                          <sh-icon id="business-partner-management-icon-plus" icon="plus" size="s" button
                            class="bp-editor__manual-user-add"
                            [disabled]="!canAddManualUserInput(index)"
                            [attr.aria-label]="'businessPartner.users.addEmailAriaLabel' | transloco"
                          (click)="addManualUserInput()"></sh-icon>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="bp-editor__footer">
                  <div class="bp-editor__status">
                    @if (formError) {
                      <span class="bp-editor__error">{{ formError }}</span>
                    }
                  </div>
                  <div class="bp-editor__actions">
                    <sh-button id="business-partner-management-button-back" [attr.label]="'businessPartner.editor.back' | transloco" icon="arrow-left" icon-position="left" color="secondary"
                    (click)="goToBaseInfoStep()"></sh-button>
                    <sh-button id="business-partner-management-button-cancel" [attr.label]="'businessPartner.editor.cancel' | transloco" size="max-content" icon="cancel" icon-position="left" color="secondary" (click)="returnToOverview()"></sh-button>
                    <sh-button id="business-partner-management-button-continue" [attr.label]="'businessPartner.editor.continue' | transloco" icon="arrow-right" size="max-content" icon-position="left" [disabled]="validatingOnboarding"
                    (click)="continueToSiteStep()"></sh-button>
                  </div>
                </div>
              </div>
            } @else {
              <div class="bp-editor__flow-section bp-editor__flow-section--sites">
                <div class="bp-editor__toolbar">
                  <div class="bp-editor__summary">
                    <div class="bp-manager__metric-label">{{ 'businessPartner.sites.metricLabel' | transloco }}</div>
                    <div class="bp-manager__metric-value">{{ getSelectedSiteCount() }}</div>
                  </div>
                  <div class="bp-editor__selectors">
                    <div class="bp-editor__selector">
                      <span class="bp-manager__metric-label">{{ 'businessPartner.sites.scopeLabel' | transloco }}</span>
                      <sh-dropdown id="business-partner-management-dropdown-30" no-border condensed [value]="scopeValue">
                        <sh-menu-item id="business-partner-management-menu-item-all-sites" [attr.label]="'businessPartner.sites.scopeAll' | transloco" [active]="scopeValue === 'All Sites'" (click)="onScopeChange('All Sites')"></sh-menu-item>
                        <sh-menu-item id="business-partner-management-menu-item-selected-sites-only" [attr.label]="'businessPartner.sites.scopeSelected' | transloco" [active]="scopeValue === 'Selected Sites Only'"
                        (click)="onScopeChange('Selected Sites Only')"></sh-menu-item>
                      </sh-dropdown>
                    </div>
                  </div>
                </div>
                @if (siteCatalogLoading) {
                  <div class="bp-manager__state bp-manager__state--loading">
                    <sh-spinner id="business-partner-management-spinner-33"></sh-spinner>
                    <sh-text id="business-partner-management-text-34" size="body-2">{{ 'businessPartner.sites.loading' | transloco }}</sh-text>
                  </div>
                }
                @if (!siteCatalogLoading && siteCatalogError && allEditableSites.length === 0) {
                  <div class="bp-manager__state bp-manager__state--error">
                    <sh-icon id="business-partner-management-icon-error" icon="error" size="m"></sh-icon>
                    <div>{{ 'businessPartner.sites.loadError' | transloco }}</div>
                  </div>
                }
                @if (!siteCatalogLoading && allEditableSites.length > 0) {
                  <div class="bp-editor__table-wrap">
                    <p-table [value]="filteredSites" [virtualScroll]="true" [virtualScrollItemSize]="64"
                      [rows]="siteTableRows" [scrollable]="true" scrollHeight="flex" [customSort]="true"
                      [tableStyle]="{ 'min-width': '76rem', 'table-layout': 'fixed' }"
                      [sortField]="sortField" [sortOrder]="sortOrder" (sortFunction)="onSiteSort($event)"
                      class="bp-sites-table">
                      <ng-template pTemplate="colgroup">
                        <colgroup>
                        <col style="width: 6rem">
                        <col style="width: 15rem">
                        <col style="width: 18rem">
                        <col style="width: 10rem">
                        <col style="width: 10rem">
                        <col style="width: 18rem">
                      </colgroup>
                    </ng-template>
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="bp-sites-table__col-include" pSortableColumn="included">{{ 'businessPartner.sites.table.include' | transloco }} <p-sortIcon field="included"></p-sortIcon></th>
                        <th class="bp-sites-table__col-name" pSortableColumn="siteName">{{ 'businessPartner.sites.table.siteName' | transloco }} <p-sortIcon field="siteName"></p-sortIcon></th>
                        <th class="bp-sites-table__col-address" pSortableColumn="address">{{ 'businessPartner.sites.table.siteAddress' | transloco }} <p-sortIcon field="address"></p-sortIcon></th>
                        <th class="bp-sites-table__col-city" pSortableColumn="city">{{ 'businessPartner.sites.table.siteCity' | transloco }} <p-sortIcon field="city"></p-sortIcon></th>
                        <th class="bp-sites-table__col-country" pSortableColumn="country">{{ 'businessPartner.sites.table.siteCountry' | transloco }} <p-sortIcon field="country"></p-sortIcon></th>
                        <th class="bp-sites-table__col-instruments" pSortableColumn="instrumentSummary">{{ 'businessPartner.sites.table.instruments' | transloco }} <p-sortIcon field="instrumentSummary"></p-sortIcon></th>
                      </tr>
                      <tr class="bp-sites-table__filters">
                        <th class="bp-sites-table__bulk-select-cell">
                          @if (hasActiveFilters() && filteredSites.length > 0) {
                            <div class="bp-sites-table__bulk-select-toggle">
                              <sh-checkbox id="business-partner-management-checkbox-36" [active]="areAllFilteredSelected()" [label]="''"
                                [attr.aria-label]="'businessPartner.sites.selectAllFilteredAriaLabel' | transloco"
                              (checked)="toggleAllFiltered()"></sh-checkbox>
                              <span>{{ 'businessPartner.sites.filterAll' | transloco }}</span>
                            </div>
                          }
                        </th>
                        <th>
                          <sh-search id="business-partner-management-search-name" no-border condensed [attr.label]="'businessPartner.customerSites.table.siteName' | transloco" [(ngModel)]="siteFilters.name" (ngModelChange)="onSiteFilterChange('name', $event)"></sh-search>
                        </th>
                        <th>
                          <sh-search id="business-partner-management-search-address" no-border condensed [attr.label]="'businessPartner.customerSites.table.address' | transloco" [(ngModel)]="siteFilters.address" (ngModelChange)="onSiteFilterChange('address', $event)"></sh-search>
                        </th>
                        <th>
                          <sh-search id="business-partner-management-search-city" no-border condensed [attr.label]="'businessPartner.customerSites.table.city' | transloco" [(ngModel)]="siteFilters.city" (ngModelChange)="onSiteFilterChange('city', $event)"></sh-search>
                        </th>
                        <th>
                          <sh-search id="business-partner-management-search-country" no-border condensed [attr.label]="'businessPartner.customerSites.table.country' | transloco" [(ngModel)]="siteFilters.country" (ngModelChange)="onSiteFilterChange('country', $event)"></sh-search>
                        </th>
                        <th>
                          <div class="bp-serial-filter">
                            <sh-search id="business-partner-management-search-serial" no-border condensed [attr.label]="'businessPartner.instruments.table.serial' | transloco" [(ngModel)]="siteFilters.serial" (ngModelChange)="onSerialFilterChange($event)"></sh-search>
                            @if (serialFilterLoading) {
                              <sh-spinner id="business-partner-management-spinner-42" size="s"></sh-spinner>
                            }
                          </div>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                      <tr class="bp-sites-table__row">
                        <td class="bp-sites-table__col-include">
                          <sh-checkbox id="business-partner-management-checkbox-43" [active]="selectedSiteIds.has(row.uid)" [label]="''" (checked)="toggleSite(row)"></sh-checkbox>
                        </td>
                        <td class="bp-sites-table__col-name" [attr.title]="row.siteName">{{ row.siteName }}</td>
                        <td class="bp-sites-table__col-address" [attr.title]="row.address">{{ row.address }}</td>
                        <td class="bp-sites-table__col-city" [attr.title]="row.city">{{ row.city }}</td>
                        <td class="bp-sites-table__col-country" [attr.title]="row.country">{{ row.country }}</td>
                        <td class="bp-sites-table__col-instruments">
                          <button type="button" class="bp-link-button bp-link-button--neutral bp-link-button--truncate"
                            [attr.title]="getInstrumentSummary(row)" (click)="openInstrumentDetails(row)">
                            {{ getInstrumentSummary(row) }}
                          </button>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="6">
                          <div class="bp-manager__state">{{ 'businessPartner.sites.empty' | transloco }}</div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              }
              <div class="bp-editor__footer">
                <div class="bp-editor__status">
                  @if (siteFilters.serial && siteFilters.serial.length < 3) {
                    <span>{{ 'businessPartner.sites.serialFilterHint' | transloco }}</span>
                  }
                  @if (formError) {
                    <span class="bp-editor__error">{{ formError }}</span>
                  }
                </div>
                <div class="bp-editor__actions">
                  <sh-button id="business-partner-management-button-back" [attr.label]="'businessPartner.editor.back' | transloco" icon="arrow-left" icon-position="left" color="secondary"
                  (click)="goToManualUsersStep()"></sh-button>
                  <sh-button id="business-partner-management-button-cancel" [attr.label]="'businessPartner.editor.cancel' | transloco" size="max-content" icon="cancel" icon-position="left" color="secondary" (click)="returnToOverview()"></sh-button>
                  <sh-button id="business-partner-management-button-save" [attr.label]="'businessPartner.editor.save' | transloco" icon="checkmark" icon-position="left" [disabled]="saving || validatingOnboarding" (click)="saveDraft()"></sh-button>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
</div>

</sh-modal>

@if (countriesDialogVisible) {
  <sh-modal [visible]="countriesDialogVisible" [sticky]="true"
    id="bp-countries-modal" [attr.label]="'businessPartner.countries.title' | transloco" modal-height="auto" [attr.modal-width]="'min(42rem, 92vw)'"
    [attr.accessible-close-label]="'businessPartner.countries.closeAriaLabel' | transloco" (modal-closed)="closeCountriesDialog()">
    <sh-icon id="business-partner-management-icon-close-countries-dialog" slot="functions" icon="cancel" size="s" button [attr.accessible-label]="'businessPartner.countries.closeAriaLabel' | transloco"
    (click)="closeCountriesDialog()"></sh-icon>
    <div class="bp-detail-list">
      @for (country of getSelectedPartnerCountries(); track country) {
        <div class="bp-detail-list__item">{{ country }}</div>
      }
      @if (getSelectedPartnerCountries().length === 0) {
        <div class="bp-manager__state">{{ 'businessPartner.countries.empty' | transloco }}</div>
      }
    </div>
    <sh-button id="business-partner-management-button-close" slot="footer" [attr.label]="'businessPartner.countries.close' | transloco" color="secondary" (click)="closeCountriesDialog()"></sh-button>
  </sh-modal>
}

@if (manualUsersDialogVisible) {
  <sh-modal [visible]="manualUsersDialogVisible" [sticky]="true"
    id="bp-manual-users-modal" [attr.label]="'businessPartner.manualUsers.title' | transloco" modal-height="auto" [attr.modal-width]="'min(42rem, 92vw)'"
    [attr.accessible-close-label]="'businessPartner.manualUsers.closeAriaLabel' | transloco" (modal-closed)="closeManualUsersDialog()">
    <sh-icon id="business-partner-management-icon-close-manually-added-user" slot="functions" icon="cancel" size="s" button [attr.accessible-label]="'businessPartner.manualUsers.closeAriaLabel' | transloco"
    (click)="closeManualUsersDialog()"></sh-icon>
    <div class="bp-detail-list">
      @for (user of getSelectedPartnerManualUsers(); track user) {
        <div class="bp-detail-list__item">{{ user }}</div>
      }
      @if (getSelectedPartnerManualUsers().length === 0) {
        <div class="bp-manager__state">{{ 'businessPartner.manualUsers.empty' | transloco }}</div>
      }
    </div>
    <sh-button id="business-partner-management-button-close" slot="footer" [attr.label]="'businessPartner.manualUsers.close' | transloco" color="secondary" (click)="closeManualUsersDialog()"></sh-button>
  </sh-modal>
}

@if (sitesDialogVisible) {
  <sh-modal [visible]="sitesDialogVisible" [sticky]="true" id="bp-sites-modal"
    [attr.label]="'businessPartner.customerSites.title' | transloco" modal-height="auto" [attr.modal-width]="'min(60rem, 96vw)'"
    [attr.accessible-close-label]="'businessPartner.customerSites.closeAriaLabel' | transloco" (modal-closed)="closeSitesDialog()">
    <sh-icon id="business-partner-management-icon-close-customer-sites-dial" slot="functions" icon="cancel" size="s" button [attr.accessible-label]="'businessPartner.customerSites.closeAriaLabel' | transloco"
    (click)="closeSitesDialog()"></sh-icon>
    <p-table [value]="getFilteredSelectedPartnerSites()" [scrollable]="true" scrollHeight="24rem">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'businessPartner.customerSites.table.siteName' | transloco }}</th>
          <th>{{ 'businessPartner.customerSites.table.address' | transloco }}</th>
          <th>{{ 'businessPartner.customerSites.table.city' | transloco }}</th>
          <th>{{ 'businessPartner.customerSites.table.country' | transloco }}</th>
        </tr>
        <tr class="bp-sites-table__filters">
          <th>
            <sh-search id="business-partner-management-search-name" no-border condensed [attr.label]="'businessPartner.customerSites.table.siteName' | transloco" [(ngModel)]="partnerSiteFilters.siteName"
            (ngModelChange)="onPartnerSiteFilterChange('siteName', $event)"></sh-search>
          </th>
          <th>
            <sh-search id="business-partner-management-search-address" no-border condensed [attr.label]="'businessPartner.customerSites.table.address' | transloco" [(ngModel)]="partnerSiteFilters.address"
            (ngModelChange)="onPartnerSiteFilterChange('address', $event)"></sh-search>
          </th>
          <th>
            <sh-search id="business-partner-management-search-city" no-border condensed [attr.label]="'businessPartner.customerSites.table.city' | transloco" [(ngModel)]="partnerSiteFilters.city"
            (ngModelChange)="onPartnerSiteFilterChange('city', $event)"></sh-search>
          </th>
          <th>
            <sh-search id="business-partner-management-search-country" no-border condensed [attr.label]="'businessPartner.customerSites.table.country' | transloco" [(ngModel)]="partnerSiteFilters.country"
            (ngModelChange)="onPartnerSiteFilterChange('country', $event)"></sh-search>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-site>
        <tr>
          <td>{{ site.siteName }}</td>
          <td>{{ site.address }}</td>
          <td>{{ site.city }}</td>
          <td>{{ site.country }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">
            <div class="bp-manager__state">{{ 'businessPartner.customerSites.empty' | transloco }}</div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <sh-button id="business-partner-management-button-close" slot="footer" [attr.label]="'businessPartner.customerSites.close' | transloco" color="secondary" (click)="closeSitesDialog()"></sh-button>
  </sh-modal>
}

@if (instrumentsDialogVisible) {
  <sh-modal [visible]="instrumentsDialogVisible" [sticky]="true"
    id="bp-instruments-modal" [attr.label]="selectedInstrumentSite?.siteName || ('businessPartner.instruments.title' | transloco)" modal-height="auto"
    [attr.modal-width]="'min(70rem, 96vw)'" [attr.accessible-close-label]="'businessPartner.instruments.closeAriaLabel' | transloco"
    (modal-closed)="closeInstrumentsDialog()">
    <sh-icon id="business-partner-management-icon-close-instrument-details" slot="functions" icon="cancel" size="s" button [attr.accessible-label]="'businessPartner.instruments.closeAriaLabel' | transloco"
    (click)="closeInstrumentsDialog()"></sh-icon>
    <div class="bp-instruments-table-wrap">
      @if (instrumentDetailsLoading) {
        <div class="bp-manager__state bp-manager__state--loading bp-instruments-table-state">
          <sh-spinner id="business-partner-management-spinner-58" size="m"></sh-spinner>
        </div>
      }
      @if (!instrumentDetailsLoading) {
        <p-table [value]="getFilteredInstrumentRows()" [scrollable]="true" scrollHeight="26rem">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'businessPartner.instruments.table.serial' | transloco }}</th>
              <th>{{ 'businessPartner.instruments.table.material' | transloco }}</th>
              <th>{{ 'businessPartner.instruments.table.productFamily' | transloco }}</th>
            </tr>
            <tr class="bp-sites-table__filters bp-instruments-table__filters">
              <th>
                <sh-search id="business-partner-management-search-serial" no-border condensed [attr.label]="'businessPartner.instruments.table.serial' | transloco" [(ngModel)]="instrumentFilters.serial"
                (ngModelChange)="onInstrumentFilterChange('serial', $event)"></sh-search>
              </th>
              <th>
                <sh-search id="business-partner-management-search-material" no-border condensed [attr.label]="'businessPartner.instruments.table.material' | transloco" [(ngModel)]="instrumentFilters.material"
                (ngModelChange)="onInstrumentFilterChange('material', $event)"></sh-search>
              </th>
              <th>
                <sh-search id="business-partner-management-search-product-family" no-border condensed [attr.label]="'businessPartner.instruments.table.productFamily' | transloco" [(ngModel)]="instrumentFilters.productFamily"
                (ngModelChange)="onInstrumentFilterChange('productFamily', $event)"></sh-search>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-instrument>
            <tr>
              <td>{{ instrument.serialNumber || '-' }}</td>
              <td>{{ instrument.materialNumber || '-' }}</td>
              <td>{{ instrument.productFamily || '-' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3">
                <div class="bp-manager__state">{{ 'businessPartner.instruments.empty' | transloco }}</div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }
    </div>
    <sh-button id="business-partner-management-button-close" slot="footer" [attr.label]="'businessPartner.instruments.close' | transloco" color="secondary" (click)="closeInstrumentsDialog()"></sh-button>
  </sh-modal>
}
